import React from "react";
import moment from "moment";
import clsx from "clsx";
import { Grid, IconButton, Typography, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      margin: "1px 0"
    },
    button: {
      width: 36,
      height: 36,
      padding: 0
    },
    selected: {
      borderRadius: "50%",
      background: theme.palette.primary.main,
      "&:hover": {
        background: theme.palette.primary.main
      },
      "& p": {
        color: "white"
      }
    },
    buttonText: {},
    today: {
      border: "1px solid rgba(0, 0, 0, 0.6)"
    }
  };
});

var Day = function Day(_a) {
  var day = _a.day,
      selected = _a.selected,
      disabled = _a.disabled,
      onClick = _a.onClick;
  var classes = useStyles();
  if (!day) return React.createElement(Grid, {
    item: true,
    className: classes.root
  }, React.createElement(Grid, {
    className: classes.button
  }));
  var isToday = day.isSame(moment(), "d");
  return React.createElement(Grid, {
    item: true,
    className: classes.root
  }, React.createElement(IconButton, {
    onClick: day ? function () {
      return onClick(day);
    } : undefined,
    disabled: disabled,
    className: clsx(classes.button, isToday && classes.today, selected && classes.selected)
  }, React.createElement(Typography, {
    variant: "body2",
    color: disabled ? "inherit" : "textPrimary",
    className: classes.buttonText
  }, day.format("D"))));
};

export default Day;